import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { Subject, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AuthService } from '@core';
import { TBaseUser } from '@core/interfaces/Endpoints';
import { TProjectItem } from '@core/interfaces/TProjectItem';
import { AllowedRoleDirective } from '@shared/directives/allowed-role.directive';

import { SpinnerComponent } from '@shared/components/spinner/spinner.component';
import { UsersSelectorComponent } from '@shared/components/users-selector/users-selector.component';
import { CommonService } from '@shared/services/common.service';
import { UsersService } from '@shared/services/users.service';

@Component({
    selector: 'app-project-users',
    templateUrl: './project-users.component.html',
    styleUrls: ['./project-users.component.scss'],
    standalone: true,
    imports: [
        MatButton,
        SpinnerComponent,
        UsersSelectorComponent, AllowedRoleDirective,
    ]
})
export class ProjectUsersComponent implements OnInit, OnDestroy {

  @Input() public selectedProject: TProjectItem = {} as TProjectItem;
  private _subs: Subscription[] = [];
  protected users: TBaseUser[] = [];
  private _usersUpdate = new Subject<void>();
  protected isLoading = true;
  protected showActionsColumn = false;

  constructor(
    private _usersService: UsersService,
    private _commonService: CommonService,
    private _authService: AuthService,
  ) {

  }


  ngOnInit(): void {
    this._subs.push(
      this._authService.user().subscribe(user => {
        this.showActionsColumn = !!user.roles?.includes('admin');
      })
    );

    this._subs.push(
      this._usersUpdate
        .pipe(
          switchMap(() => this._usersService.getUsersForProject(this.selectedProject._id!),
          ),
        ).subscribe(users => {
        this.users = users;
        this.isLoading = false;
      }),
    );

    this._usersUpdate.next();
  }

  protected attachUsers(usersIds: string[]) {
    this._subs.push(this._usersService.attachUsersToProject(this.selectedProject._id!, usersIds).subscribe({
      next: () => {
        this._commonService.openSuccessSnackBar('Users assigned successfully');
        this._usersUpdate.next();
      },
      error: () => this._commonService.openErrorSnackBar('Users assigned failed'),
    }));
  }

  protected detachUser(user: TBaseUser) {
    this._subs.push(
      this._usersService.detachUserFromProject(this.selectedProject._id!, user.username!).subscribe({
        next: () => {
          this._commonService.openSuccessSnackBar(`User "${user.username}" was detached from project"`);
          this.users = this.users.filter(usr => usr._id !== user._id);
        },
        error: () => this._commonService.openErrorSnackBar('There was an error during detaching user from project'),
      }),
    );
  }

  ngOnDestroy(): void {
    this._subs.forEach(sub => sub.unsubscribe());
  }

}
